function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 9C0 8.44772 0.447715 8 1 8H47C47.5523 8 48 8.44772 48 9C48 9.55228 47.5523 10 47 10H0.999999C0.447714 10 0 9.55228 0 9Z",
  fill: "#EAEEF4"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 18.3333,
  y: 15.3333,
  width: 36,
  height: 2,
  rx: 1,
  fill: "#EAEEF4"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M118 46.875C118 46.3918 118.392 46 118.875 46H165.125C165.608 46 166 46.3918 166 46.875C166 47.3582 165.608 47.75 165.125 47.75H118.875C118.392 47.75 118 47.3582 118 46.875Z",
  fill: "#EAEEF4"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M113 52.125C113 51.6418 113.392 51.25 113.875 51.25H142.125C142.608 51.25 143 51.6418 143 52.125C143 52.6082 142.608 53 142.125 53H113.875C113.392 53 113 52.6082 113 52.125Z",
  fill: "#EAEEF4"
});

var _ref6 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 79,
  cy: 88.5,
  rx: 60,
  ry: 9.5,
  fill: "#F5F8FA"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 46,
  cy: 17,
  r: 17,
  fill: "#EAEEF4"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 113.5,
  cy: 31.5,
  r: 11.5,
  fill: "#EAEEF4"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M61 17H107C109.209 17 111 18.7909 111 21V79C111 81.2091 109.209 83 107 83H61V17Z",
  fill: "#00BAFF"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M48 21C48 18.7909 49.7909 17 52 17H61V83H52C49.7909 83 48 81.2091 48 79V21Z",
  fill: "url(#paint0_linear)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M76 56C76 53.7909 77.7909 52 80 52H92C94.2091 52 96 53.7909 96 56V83H76V56Z",
  fill: "white"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M91.8476 29.5399C92.012 29.6064 92.4529 29.7895 92.8278 29.9992C93.4587 30.4066 94.2238 31.7815 94.2238 31.7815C94.2238 31.7815 94.7017 32.459 94.6943 32.5466C94.6715 32.7956 94.5572 33.015 94.4696 33.1824C94.467 33.1872 94.4643 33.1925 94.4613 33.1981C94.3618 33.3879 94.025 34.0304 93.7488 34.2164C93.4644 34.408 92.3448 34.9405 91.4499 35.216C91.2053 35.3007 90.724 35.5067 90.4476 35.8343C90.1199 36.2223 86.7646 39.8116 86.7646 39.8116L86.2452 39.652C86.2452 39.652 87.1156 38.5696 86.8528 37.2056C86.6423 36.1135 86.0825 35.4892 86.0825 35.4892C86.0825 35.4892 86.9796 36.9227 86.2668 38.5321C86.107 38.8936 85.7946 39.3365 85.4294 39.6653C85.3616 39.7224 85.3055 39.7615 85.265 39.7898C85.178 39.8506 85.1627 39.8612 85.257 39.8913C85.344 39.9192 85.4288 39.946 85.5497 39.9843C85.7854 40.059 86.1587 40.1772 86.9546 40.4316C87.7732 40.6849 87.9695 41.3617 87.9428 41.6361C87.9325 41.7443 87.879 41.9999 87.879 41.9999L84.3872 40.8583C84.3872 40.8583 82.0298 40.0763 81.908 40.0642C81.7026 40.0442 81.3511 39.7777 81.3454 39.4804C81.3442 39.4207 81.3446 39.3544 81.345 39.286C81.3463 39.0509 81.3478 38.7893 81.2879 38.6742C81.2532 38.6237 81.1598 38.5199 81.0294 38.3748C80.7066 38.0157 80.1567 37.4041 79.7081 36.7257C79.1387 35.8651 78.8997 34.9356 79.0386 33.9403C79.2837 32.1882 81.28 30.7734 82.8518 31.0611C83.1518 31.1158 83.4933 31.1952 83.9633 31.3046C84.9012 31.5228 86.3506 31.86 89.0032 32.3568C88.9394 31.6479 89.1619 31.0097 89.5021 30.461C89.3689 30.2766 88.8018 29.8016 87.7129 30.0198C86.7504 30.2132 85.9687 30.183 85.492 30.1528C84.8304 30.1108 82.896 29.4196 81.9596 29.0851C81.71 28.9959 81.5313 28.9321 81.4666 28.9126C81.0359 28.7839 81.3232 28.5355 81.6304 28.3977C81.7658 28.3367 81.9888 28.2382 82.3506 28.1215C83.2307 28.5585 84.2774 29.022 85.2542 29.3308C85.7525 29.488 86.6087 29.5635 87.6737 29.494C88.7801 29.4215 89.6096 29.685 89.8275 30.0138C89.708 29.8125 89.1158 29.2607 87.8984 29.2879C86.8317 29.3121 85.9966 29.1314 85.4903 29.0081C84.9607 28.8794 83.7421 28.1717 82.7739 27.5836C82.5111 27.4245 82.2668 27.2742 82.0595 27.1467C81.7435 26.9524 81.5137 26.811 81.4364 26.772C81.0535 26.581 81.2874 26.4759 81.6367 26.3864C81.6689 26.3782 81.7076 26.3677 81.7528 26.3555C82.1217 26.2554 82.9232 26.0381 84.1403 26.002C85.6184 25.9576 87.0779 26.6478 88.0824 27.1229C88.2532 27.2037 88.4108 27.2782 88.5532 27.3419C89.5328 27.7795 91.7543 29.468 91.7543 29.468C91.7543 29.468 91.7907 29.4964 91.8476 29.5399ZM83.0844 41.6993C82.7954 41.5192 82.8643 41.1862 83.0628 41.0611C83.2027 40.991 83.3381 41.0515 83.3381 41.0515L84.2023 41.341C84.2023 41.341 83.341 41.8426 83.0844 41.6993Z",
  fill: "white"
});

var _ref13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 60.894,
  y1: 82.0198,
  x2: 44.2252,
  y2: 81.0372,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#007CFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00BAFF"
})));

function SvgBlueLoggiAgency(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 98,
    viewBox: "0 0 166 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
}

var ForwardRef = React.forwardRef(SvgBlueLoggiAgency);
export default __webpack_public_path__ + "static/media/blue-loggi-agency.6995d709.svg";
export { ForwardRef as ReactComponent };